document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('main[data-endpoint-url]');
  const endpointUrl = root && root.dataset ? root.dataset.endpointUrl : null;
  const redirectUrl = root && root.dataset ? root.dataset.redirectUrl : null;
  const votingStatus =
    (
      (root && root.dataset && root.dataset.votingStatus) ||
      ''
    ).toLowerCase() === 'true';

  const voteRadios = document.querySelectorAll('input[name="vote"]');
  if (voteRadios.length) {
    const resetChevrons = () => {
      document.querySelectorAll('.chevron-text').forEach((el) => {
        el.textContent = 'Udělit hlas';
        el.classList.remove('c-main');
      });
    };
    voteRadios.forEach((radio) => {
      radio.addEventListener('change', function () {
        resetChevrons();
        if (this.checked) {
          const paymentItem = this.closest('.payment-item');
          const myChevron = paymentItem
            ? paymentItem.querySelector('.chevron-text')
            : null;
          if (myChevron) {
            myChevron.textContent = 'Váš hlas';
            myChevron.classList.add('c-main');
          }
        }
      });
    });
  }

  const pointSelects = Array.from(document.querySelectorAll('.vote-points'));

  // 🛑 Pokud stránka žádné hlasování neobsahuje, ukončíme script hned tady
  if (!pointSelects.length) {
    return;
  }

  const campaignCount = pointSelects.length;
  const mainPrize = document.getElementById('main-prize');
  const submitBtn = document.getElementById('vote-submit');
  const pointsError = document.getElementById('points-error') || null;
  const mainPrizeError = document.getElementById('main-prize-error') || null;
  const form = document.querySelector('form');

  // 🧠 Dynamicky omezíme možnosti podle počtu kampaní
  pointSelects.forEach((select) => {
    Array.from(select.options).forEach((option) => {
      if (!option.value) return;

      if (campaignCount === 1) {
        if (option.value !== '3') option.remove();
      } else if (campaignCount === 2) {
        if (option.value !== '3' && option.value !== '2') option.remove();
      } else if (campaignCount === 3) {
        if (
          option.value !== '3' &&
          option.value !== '2' &&
          option.value !== '1'
        )
          option.remove();
      } else if (campaignCount >= 4) {
        if (
          option.value !== '3' &&
          option.value !== '2' &&
          option.value !== '1' &&
          option.value !== '0'
        )
          option.remove();
      }
    });
  });

  const refreshDisables = () => {
    const used = new Set(
      pointSelects.map((select) => select.value).filter((v) => v && v !== '0')
    );
    pointSelects.forEach((select) => {
      Array.from(select.options).forEach((option) => {
        if (!option.value) return;
        if (option.value !== '0') {
          option.disabled =
            used.has(option.value) && select.value !== option.value;
        } else {
          option.disabled = false;
        }
      });
    });
  };

  const validatePoints = () => {
    const values = pointSelects.map((select) => select.value);
    const allSelected = values.every((v) => v !== '');
    const unique = new Set(values);
    const noDuplicates = unique.size === values.length;

    let requiredPoints = [];
    if (campaignCount === 1) {
      requiredPoints = ['3'];
    } else if (campaignCount === 2) {
      requiredPoints = ['3', '2'];
    } else if (campaignCount === 3) {
      requiredPoints = ['3', '2', '1'];
    } else if (campaignCount >= 4) {
      requiredPoints = ['3', '2', '1'];
    }

    const allRequiredUsed = requiredPoints.every((p) => values.includes(p));
    const zeroAllowed = campaignCount >= 4;
    const hasZero = values.includes('0');

    if (hasZero && !zeroAllowed) {
      if (pointsError) pointsError.hidden = false;
      return false;
    }

    const ok = allSelected && noDuplicates && allRequiredUsed;
    if (pointsError) {
      pointsError.hidden = ok;
    }
    return ok;
  };

  const validateMainPrize = () => {
    const ok = !!(mainPrize && mainPrize.value);
    if (mainPrizeError) {
      mainPrizeError.hidden = ok;
    }
    return ok;
  };

  pointSelects.forEach((select) => {
    select.addEventListener('change', () => {
      refreshDisables();
      validatePoints();
    });
  });

  if (mainPrize) mainPrize.addEventListener('change', validateMainPrize);

  refreshDisables();

  if (form) {
    form.addEventListener('submit', (event) => {
      const ok = validateMainPrize() && validatePoints();
      if (!ok) {
        event.preventDefault();
        if (pointsError) {
          pointsError.hidden = false;
        }
        const firstErr =
          (mainPrizeError &&
            mainPrizeError.hidden === false &&
            mainPrizeError) ||
          (pointsError && pointsError.hidden === false && pointsError) ||
          null;
        if (firstErr) {
          firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  }

  const checkEndpoint = async () => {
    if (!endpointUrl || !redirectUrl) return;
    try {
      const res = await fetch(endpointUrl, { cache: 'no-store' });
      const data = await res.json();
      if (data !== votingStatus) {
        window.location.href = redirectUrl;
      }
    } catch (err) {
      console.error('Error fetching the endpoint:', err);
    }
  };

  if (endpointUrl && redirectUrl) {
    setInterval(checkEndpoint, 5000);
  }
});
